// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-main {
  flex: 1 1;
  margin-left: 230px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: margin-left 0.3s;
}

.layout-main.collapsed {
  margin-left: 60px;
}

.layout-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  padding-top: 70px;
  background-color: #0C111D; /* Match with table wrapper */
  color: white; /* 👈 White text */
}

/* Page heading */
.page-heading {
  padding-left: 35px;
  border-bottom: 1px solid #334155; /* Dark border for subtle contrast */
  background: #1a2234; /* Match with table row background */
  color: white; /* 👈 White text */
  position: sticky;
  top: 60px;
  font-size: 10px; /* Adjusted for readability */
  font-weight: 600;
  z-index: 500;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/MainLayout.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB,EAAE,6BAA6B;EACxD,YAAY,EAAE,kBAAkB;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gCAAgC,EAAE,oCAAoC;EACtE,mBAAmB,EAAE,oCAAoC;EACzD,YAAY,EAAE,kBAAkB;EAChC,gBAAgB;EAChB,SAAS;EACT,eAAe,EAAE,6BAA6B;EAC9C,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".layout-main {\n  flex: 1;\n  margin-left: 230px;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  transition: margin-left 0.3s;\n}\n\n.layout-main.collapsed {\n  margin-left: 60px;\n}\n\n.layout-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  padding-top: 70px;\n  background-color: #0C111D; /* Match with table wrapper */\n  color: white; /* 👈 White text */\n}\n\n/* Page heading */\n.page-heading {\n  padding-left: 35px;\n  border-bottom: 1px solid #334155; /* Dark border for subtle contrast */\n  background: #1a2234; /* Match with table row background */\n  color: white; /* 👈 White text */\n  position: sticky;\n  top: 60px;\n  font-size: 10px; /* Adjusted for readability */\n  font-weight: 600;\n  z-index: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
